export let compare = (propertyName,type) =>{
     if(type==='asc')
     {
         return function(obj1,obj2){
             let val1 = obj1[propertyName];
             let val2 = obj2[propertyName];
             if(val2 < val1){
                 return 1;
             }else if(val2 > val1)
             {
                 return -1;
             }else{
                 return 0;
             }
         }
     }else if(type === 'desc')
     {
        return function(obj1,obj2){
            let val1 = obj1[propertyName];
            let val2 = obj2[propertyName];
            if(val2 > val1){
                return 1;
            }else if( val2 < val1)
            {
                return -1;
            }else{
                return 0;
            }
        }
     }
};
//use : console.log(data.sort(compare('value','asc')));

export let  swap = (arr, indexA, indexB)=> {
    [arr[indexA], arr[indexB]] = [arr[indexB], arr[indexA]];
  };

  export let  bubbleSort = (arr, compareFunc)=> {
    for (let i = arr.length - 1; i > 0; i--) {
      for (let j = 0; j < i; j++) {
        if (compareFunc(arr[j], arr[j + 1]) > 0) {
          swap(arr, j, j + 1);
        }
      }
    }
    return arr;
  };
  //use const arr = [91, 60, 96, 7, 35, 65, 10, 65, 9, 30, 20, 31, 77, 81, 24];
  //console.log(bubbleSort(arr, (a, b) => a - b));